import { Avatar, Box, Container, createTheme, CssBaseline, ThemeProvider, Typography } from "@mui/material";
import QRCode from "react-qr-code";
import { useParams } from "react-router-dom";
const theme = createTheme();

export default function Qr() {
  const location = useParams().location || 'sydney';
  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 2,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >         
          <Avatar alt="Logo"
            src="https://housedownunder.com.au/wp-content/uploads/2021/03/DOWN-UNDER-Logo-RGB.png"
            sx={{ width: 150, height: 150 }} />      
            <Typography sx={{textAlign: 'center'}} component="div">
              Join the queue with QR code
            </Typography>
            <div style={{ background: 'white', padding: '16px' }}>
              <QRCode value={`${process.env.REACT_APP_URL}/join/${location}`} />
            </div>
        </Box>
      </Container>
    </ThemeProvider>
  );
}
